import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function CategoryGrid() {
  return (
    <section className="w-full">
      <div className="mb-8 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          <h2 className="font-heading text-2xl font-700 text-foreground-950 md:text-3xl">鉴定主题分类</h2>
          <p className="mt-2 text-sm text-foreground-600">按主题进入专区，快速找到你关心的那类传言。</p>
        </div>
        <Link
          to="/verify"
          className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-500 text-primary-700 transition-colors hover:text-primary-800"
        >
          查看全部条目
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((c) => (
          <Link
            key={c.key}
            to={`/verify?category=${c.key}`}
            className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-background-100 md:p-5"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-secondary-500 group-hover:text-background-50">
              <i className={`${c.icon} text-xl`}></i>
            </span>
            <span className="flex flex-1 flex-col">
              <span className="flex items-center justify-between">
                <span className="font-heading text-base font-600 text-foreground-950">{c.key}</span>
                <span className="font-label text-xs text-foreground-500">{c.count} 条</span>
              </span>
              <span className="mt-1.5 text-sm leading-relaxed text-foreground-600">{c.desc}</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}